import { gql } from '@apollo/client'

export const LINK_QUERY = gql`
query LinkQuery($id: String!){
  nodeById(id: $id) {
    entityType
    entityBundle
    entityId
    entityLabel
    entityChanged
    ... on NodePlaylist {
      isLikedByCurrentUser
      fieldPlaylistImportedFromSap
      fieldPlaylistDescription
      title
      uuid
    }
    ... on NodeResource {
      uuid
      entityId
      entityLabel
      entityType
      fieldResourceDescription
      isLikedByCurrentUser
      fieldResourceImportedFromSap
      fieldResourceFromDate
      fieldResourceReleaseDate
      fieldResourceOfflinePeriod {
        targetId
      }  
      fieldResourceFilesByFormat {
        entity {
          ... on Media {
            entityLabel
            entityType
            entityBundle
            entityId
            uuid
          }
          ... on MediaMediaFile {
            fieldMediaFileLanguage {
              value
            }
            fieldMediaFile {
              entity {
                ... on File {
                  entityChanged
                  url
                  filesize
                  filemime
                  filename
                }
              }
            }
          }
          ... on MediaSapFile {
            entityChanged
            entityId
            fieldSapFromDate
            fieldSapReleaseDate
            fieldSapFileFileSize
            fieldSapFileFileName
            fieldSapFileDocumentVersion
            fieldSapFileMime
            fieldSapFileLanguage {
              value
            }
            fieldSapFileFileExtension {
              entity {
                ... on TaxonomyTermFileExtension {
                  fieldFileExtensionValue
                }
              }
            }
          }
          ... on MediaMasterControl {
             uuid
             entityChanged
             entityId
             fieldMasterControlId
             fieldMasterControlCategory
             fieldMasterControlDescription
             fieldMasterControlTitle
             fieldMasterControlRevision
             fieldMasterControlMime
             fieldMasterControlSize
             fieldMasterControlExtension {
              entity {
                ... on TaxonomyTermFileExtension {
                  fieldFileExtensionValue
                }
              }
             }
          }
          ... on MediaMasterControlAttachment {
             uuid
             entityChanged
             entityId
             fieldMcAttachmentId
             fieldMcAttachmentName
             fieldMcAttachmentDescription
             fieldMcAttachmentMime
             fieldMcAttachmentSize
             fieldMcAttachmentExtension {
              entity {
                ... on TaxonomyTermFileExtension {
                  fieldFileExtensionValue
                }
              }
             }
          }
          ... on MediaBokeccVideo {
            fieldBokeccIframe
          }
        }
      }
    }
  }
}
`
;
